import React, { useState } from 'react';
import styles from '../static/styles/MessagePopup.module.css';
import { callGameNow } from '../api/rewards';
import MessagePopup from '../components/MessagePopup';

const GameNowPopup = ({ isOpen, onClose }) => {
    const [error, setError] = useState();
    const [msisdn, setMsisdn] = useState();
    const [isPopupOpen, setIsPopupOpen] = useState();
    const [message, setMessage] = useState(null);

    if (!isOpen) return null;

    const handleSubmit = async () => {
        if (!msisdn.startsWith('0') || msisdn.length !== 11) {
            setError('Please enter a valid Jazz number (starting with 0 and 11 digits long)');
            return;
        }

        const formattedMsisdn = `92${msisdn.slice(1)}`;
        // console.log('Formatted MSISDN for API:', formattedMsisdn);
        const response = await callGameNow({ msisdn: formattedMsisdn });
        if (response.status === 200 && response.data.success) {
            setMessage(response.data.message);
            setError('');
            setIsPopupOpen(true);
            return;
        } else {
            setError('Please try again later')
        }
    };

    const handleChange = (e) => {
        const value = e.target.value;

        if (/^\d{0,11}$/.test(value)) {
            setMsisdn(value);
        }
    };

    return (
        <div className={styles.popupOverlay} onClick={onClose}>
            <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
                <span className={styles.closeIcon} onClick={onClose}>
                    &times;
                </span>
                <div className={styles.formGroup}>
                    <label>Please enter your valid jazz number</label>
                    <input
                        type="text"
                        value={msisdn}
                        onChange={handleChange}
                        placeholder="Enter Jazz number"
                        maxLength={11}
                    />
                </div>
                {error && <div className={styles.errorMessage}>{error}</div>}
                <button className={styles.closeButton} onClick={handleSubmit}>
                    Submit
                </button>
            </div>

            <MessagePopup
                isOpen={isPopupOpen}
                message={message}
                onClose={onClose}
            />
        </div>
    );
};

export default GameNowPopup;